import React from 'react'
import Layout from './src/components/Layout/Layout'
import { PageTransitionProvider } from './src/context/PageTransitionContext'
import PageTransitionOverlay from './src/components/PageTransitionOverlay'

export const wrapRootElement = ({ element }) => {
  return (
    <PageTransitionProvider>
      {element}
      <PageTransitionOverlay />
    </PageTransitionProvider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload()
